import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React, { useEffect, useState } from 'react';
import {
  Typography,
  VertButton,
  VertContainer,
  VertIcon,
} from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { Col, Flex, Row, Table } from 'antd';
import { formatToString } from 'Utils/format';
import { LuTruck } from 'react-icons/lu';
import ModalSpotTracking from 'components/Spot/SpotTrackingModal';
import OrderStatusTracking from 'components/Spot/Spot/OrderStatusTracking';
import { useMediaQuery } from 'react-responsive';

export const SpotProducts = ({ spot }) => {
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });
  const [products, setProducts] = useState([]);
  const [productsTotalPrice, setProductsTotalPrice] = useState(0);
  const [openModalSpotTracking, setOpenModalSpotTracking] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    let _products = [];
    if (spot.products.length > 0) {
      _products = [];

      _products = spot.products.map((product) => {
        return {
          name: product.name,
          unitPrice: product.unitPrice,
          quantity: product.quantity,
          total: product.unitPrice * product.quantity,
          unitPointsPrice: product.unitPointsPrice,
          isChecked: false,
          approved: product.approved,
          redemptionProductId: product.id,
          trackingStatusCodeId: product.trackingStatusCodeId,
          trackingStatusCode: product.trackingStatusCode,
        };
      });

      if (_products.length > 0) {
        const approvedProducts = _products.filter(
          (product) => product.approved === true
        );
        const totalPrice = approvedProducts.reduce((accumulator, object) => {
          return accumulator + object.unitPrice * object.quantity;
        }, 0);

        if (spot.redemptionStatusId === 6) {
          setProductsTotalPrice(totalPrice);
        }

        setProductsTotalPrice(totalPrice);
      } else {
        setProductsTotalPrice(0);
      }
    }

    setProducts(_products);
  }, [spot.products]);

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      showSorterTooltip: false,
      width: 200,
    },
    {
      title: 'Valor em Reais',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      sorter: (a, b) => a.unitPrice - b.unitPrice,
      showSorterTooltip: false,
      render: (unitPrice, product) => (
        <div>
          {formatToString(unitPrice, 'currency')} <br />
          {formatToString(product.unitPointsPrice) + ' pontos'}
        </div>
      ),
      width: 100,
    },
    {
      title: mediaQuery ? 'Qtd' : 'Quantidade',
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: (a, b) => a.quantity - b.quantity,
      showSorterTooltip: false,
      width: 100,
    },
    {
      title: 'Total em Reais',
      dataIndex: 'total',
      key: 'total',
      sorter: (a, b) => a.total - b.total,
      showSorterTooltip: false,
      render: (total, product) => (
        <div>
          {formatToString(total, 'currency')} <br />
          {formatToString(product.unitPointsPrice * product.quantity) +
            ' pontos'}
        </div>
      ),
      width: 100,
    },
    {
      title: 'Último status',
      dataIndex: 'trackingStatusCodeId',
      key: 'trackingStatusCodeId',
      hidden: spot.redemptionStatusId !== 6 || spot.type == 3 || spot.type == 4,
      render: (trackingStatusCodeId, { trackingStatusCode }) => {
        return (
          <OrderStatusTracking
            trackingStatusCode={trackingStatusCodeId}
            dotStatus={false}
            trackingText={trackingStatusCode}
          />
        );
      },
      width: 300,
    },
    {
      title: 'Ações',
      dataIndex: 'tracking',
      key: 'tracking',
      render: (_, { redemptionProductId }) => (
        <Flex
          justify="center"
          align="center"
          style={{
            width: '100%',
          }}
        >
          <VertButton
            type="highlight"
            size="small"
            shape="round"
            onClick={() => {
              setSelectedProductId(redemptionProductId);
              setSelectedProduct(
                spot.products.find(
                  (product) => product.id === redemptionProductId
                )
              );
              setOpenModalSpotTracking(true);
            }}
            icon={<LuTruck size={25} />}
          />
        </Flex>
      ),
      width: 100,
      hidden: spot.redemptionStatusId !== 6 || spot.type == 3 || spot.type == 4,
    },
  ];

  return (
    <>
      <VertContainer className="container-subtitle-view-redemption">
        <VertIcon
          size="large"
          className="spacing-icon"
          isVertice
          iconName="Shop"
        />
        <Typography.Text className="subtitle-view-redemption">
          Produto
        </Typography.Text>
      </VertContainer>

      <VertContainer>
        <Table
          pagination={false}
          bordered
          columns={columns}
          dataSource={products}
          tableLayout="auto"
          sticky
          scroll={{ x: 1000 }}
          size={'small'}
          rowClassName={(record, index) => {
            const product = products[index];
            // const productQuote = findProductQuote(product.id);

            let blockedText =
              spot.redemptionStatusId === 1 ? '' : 'blocked-text';

            if (spot.redemptionStatusId > 2 && spot.type !== 4) {
              blockedText = product.approved ? '' : 'blocked-text';
            }

            return blockedText;
          }}
        />

        <VertContainer className="container-total-value">
          <Row>
            <Col xs={12} sm={12} md={12} lg={20} xl={20} xxl={20}>
              <VertContainer>
                <Typography.Text className="text-total-value">
                  VALOR TOTAL
                </Typography.Text>
              </VertContainer>
            </Col>

            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
              <VertContainer className="col-total-value">
                <Typography.Text className="text-total-value">
                  {formatToString(productsTotalPrice, 'currency')} <br />
                  {spot !== null &&
                    spot.redemptionStatusId > 2 &&
                    formatToString(spot.totalPoints) + ' pontos'}
                </Typography.Text>
              </VertContainer>
            </Col>
          </Row>

          <ModalSpotTracking
            productId={selectedProductId}
            productData={selectedProduct}
            isOpen={openModalSpotTracking}
            onClose={() => setOpenModalSpotTracking(false)}
            spot={spot}
          />
        </VertContainer>
      </VertContainer>
    </>
  );
};

SpotProducts.propTypes = {
  spot: PropTypes.object.isRequired,
};
